import { createNullableProvideInject } from '@collector/shared-ui'

import { IncidentsTeamPossessionConfig } from '../configuration'

export const [
  provideIncidentsTeamPossessionConfig,
  injectIncidentsTeamPossessionConfig,
] = createNullableProvideInject<IncidentsTeamPossessionConfig>(
  'incidentsTeamPossessionConfig',
)
